<template>
  <div class="login d-flex flex-wrap justify-content-center align-items-center">
    <div class="login-content d-flex">
      <div class="logo">
        <img src="@/assets/images/dpsp/logo-dpsp-white.png" alt="" />
      </div>

      <div class="login-content__box">
        <form @submit.prevent="submit">
          <div class="form-group form-row">
            <div class="col-6">
              <FloatingLabel
                type="text"
                input-class="form-control form-control-xl bg-color-4 border-1"
                label="Nome"
                v-model="firstName"
                v-on:blur="checkName"
              />
              <small class="form-text text-danger" v-if="nameMessage">{{
                nameMessage
              }}</small>
            </div>

            <div class="col-6">
              <FloatingLabel
                type="text"
                input-class="form-control form-control-xl bg-color-4 border-1"
                label="Sobrenome"
                v-model="lastName"
              />
            </div>
          </div>

          <div class="form-group">
            <FloatingLabel
              type="email"
              input-class="form-control form-control-xl bg-color-4 border-1"
              label="E-mail"
              v-model="email"
              v-on:blur="checkEmail.length > 0 && checkEmailConfirm()"
            />
            <small class="form-text text-danger" v-if="emailMessage">{{
              emailMessage
            }}</small>
          </div>

          <div class="form-group">
            <FloatingLabel
              type="email"
              input-class="form-control form-control-xl bg-color-4 border-1"
              label=" Repita seu e-mail"
              v-model="emailConfirm"
              v-on:blur="checkEmailConfirm"
            />
            <small class="form-text text-danger" v-if="emailConfirmMessage">{{
              emailConfirmMessage
            }}</small>
          </div>

          <div class="form-group">
            <FloatingLabel
              input-class="form-control form-control-xl bg-color-4 border-1"
              label="CPF"
              v-model="document"
              v-on:blur="checkDocument"
              v-mask="'###.###.###-##'"
            />
            <small class="form-text text-danger" v-if="documentMessage">{{
              documentMessage
            }}</small>
          </div>

          <div class="form-group form-row">
            <div class="col-6">
              <FloatingLabel
                type="password"
                input-class="form-control form-control-xl bg-color-4 border-1"
                label="Senha"
                v-b-tooltip.focus="'Sua senha deve ter no mínimo 8 caracteres'"
                v-model="password"
                v-on:blur="passwordConfirm.length > 0 && checkPasswordConfirm()"
              />
            </div>

            <div class="col-6">
              <FloatingLabel
                type="password"
                input-class="form-control form-control-xl bg-color-4 border-1"
                label="Repita sua senha"
                v-model="passwordConfirm"
                v-on:blur="checkPasswordConfirm"
              />
              <small
                class="form-text text-danger"
                v-if="passwordConfirmMessage"
                >{{ passwordConfirmMessage }}</small
              >
            </div>
          </div>

          <p class="text-muted mt-5 mb-3 text-center semi-small">
            Ao continuar, você concorda com a coleta e uso de dados pessoais
            para fins exclusivos de recrutamento e seleção.
          </p>

          <div class="text-center mt-3">
            <router-link to="/login" class="text-blue-ml font-weight-bold mr-3"
              >Voltar para Login</router-link
            >
            <button
              type="submit"
              class="btn btn-blue-ml px-4 py-3"
              :disabled="!canSubmit"
            >
              Cadastrar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import FloatingLabel from "@/components/FloatingLabel";

export default {
  name: "RegisterForm",

  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      emailConfirm: "",
      isForeign: this.$store.state.deviseTrying.isForeign || false,
      document: this.$store.state.deviseTrying.document || "",
      password: "",
      passwordConfirm: "",
      unique_id: "",

      nameMessage: null,
      emailMessage: null,
      documentMessage: null,
      passwordConfirmMessage: null,
      emailConfirmMessage: null,
      loading: false,
    };
  },

  computed: {
    canSubmit() {
      return (
        this.firstName.length > 2 &&
        this.lastName.length > 2 &&
        this.$helpers.isEmail(this.email) &&
        ((this.isForeign && this.document.length > 5) ||
          (!this.isForeign && this.$helpers.isCPF(this.document))) &&
        this.$helpers.validPassword(this.password) &&
        this.email == this.emailConfirm &&
        this.password == this.passwordConfirm &&
        this.loading == false
      );
    },
  },

  components: {
    FloatingLabel,
  },

  watch: {
    // Limpa documento quando muda a flag de estrangeiro
    isForeign: function (newValue, oldValue) {
      this.document = "";
      this.documentMessage = null;
    },
  },

  methods: {
    checkName() {
      this.nameMessage = this.firstName.length > 2 ? null : "Nome muito curto";
    },

    checkEmail() {
      this.emailMessage = this.$helpers.isEmail(this.email)
        ? null
        : "E-mail inválido";
    },

    checkEmailConfirm(){
        this.emailConfirmMessage = this.email == this.emailConfirm ? null : 'E-mails diferentes';
    },

    checkDocument() {
      if (!this.isForeign) {
        this.documentMessage = this.$helpers.isCPF(this.document)
          ? null
          : "CPF inválido";
      } else {
        this.documentMessage = this.document.length > 5 ? null : "RNE inválido";
      }
    },

    checkPasswordConfirm() {
      this.passwordConfirmMessage =
        this.password == this.passwordConfirm ? null : "Senhas diferentes";
    },

    submit() {
      let current_profile = this.$store.state.deviseTrying;
      current_profile.first_name = this.firstName;
      current_profile.last_name = this.lastName;
      current_profile.email = this.email;
      current_profile.isForeign = this.isForeign;
      current_profile.document = this.document;
      current_profile.unique_id = this.unique_id;
      current_profile.password = this.password;
      current_profile.provider = null;
      current_profile.id = null;
      this.$store.commit("DEVISE_TRYING", current_profile);

      this.signUp();
    },

    signUp() {
      this.loading = true;
      this.$store.commit("DEVISE_LOADING", true);
      const {
        first_name,
        last_name,
        email,
        isForeign,
        document,
        unique_id,
        password,
        provider,
        id,
      } = this.$store.state.deviseTrying;

      const params = {
        first_name: first_name,
        last_name: last_name,
        email: email,
        foreigner: isForeign,
        document: document,
        password: password,
        provider: provider,
        provider_id: id,
      };

      this.$store
        .dispatch("user/employerSignUp", params)
        .then(async (response) => {
          if (response.error) {
            this.$swal("Uoops", "Colaborador não encontrado", "error");
            this.$store.commit("DEVISE_LOADING", false);
            this.loading = false;
          } else {
            const acceptTermsOfUse = await this.$store.dispatch(
              "user/acceptTermsOfUse",
              { source: "carreiras" }
            );
            this.$store.commit("DEVISE_LOADING", "complete");

            setTimeout(() => {
              // Tempo para aparecer uma mensagem de complete
              this.$store.commit("DEVISE_FORM", null);
              this.$store.commit("DEVISE_LOADING", false);

              let { path, query, name } = this.$store.state.user.nextRoute;
              if (name == "ficha") {
                this.$router.push({ path: path, query: query });
              } else {
                this.$router.push("/deixe-seu-perfil");
              }

              this.$store.dispatch("user/companyFollow");
              this.initFBPixel();
              this.loading = false;
            }, 3000);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-content {
  width: 90%;
  max-width: 600px;
  height: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 14px;

  /deep/ .modal-content {
    border-radius: 16px;
  }

  /deep/ .form-control {
    font-size: inherit;
  }

  /deep/ .btn {
    min-height: 45px;
  }

  .logo {
    margin-bottom: 2rem;
    img {
      width: 300px;
    }
  }
  &__box {
    background-color: #fff;
    width: 100%;
    z-index: 999;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 0px 5px rgba(#000, 0.05);
    padding: 3rem 3rem 3rem 3rem;
  }
  .enter {
    position: absolute;
    right: -1.75rem;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 100px;
    border: none;
    background-color: #4a5b75;
    color: #fff;
    width: 3.5rem;
    height: 3.5rem;
    cursor: pointer;
    &:hover {
      background-color: lighten(#4a5b75, 10);
    }
  }
}

.login {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: theme-color(primary);
  z-index: 1060;
}

.has-no-account {
  color: #fff;
  margin: 10px auto;
}
</style>